module.exports = __webpack_public_path__ + "img/create-order.192965ab.jpg";